import { Card, CardContent, Input, Label, MoneyInput } from '@estac1/ui';

interface PricingLimitsCardProps {
  minimumCents: number;
  maxVacancies: number;
  trialDays: number;
  onMinimumCents: (v: number) => void;
  onMaxVacancies: (v: number) => void;
  onTrialDays: (v: number) => void;
}

export const PricingLimitsCard = ({
  minimumCents,
  maxVacancies,
  trialDays,
  onMinimumCents,
  onMaxVacancies,
  onTrialDays,
}: PricingLimitsCardProps) => (
  <Card>
    <CardContent className="grid gap-4 pt-6 sm:grid-cols-2">
      <div>
        <Label htmlFor="minimum">Piso mensal</Label>
        <MoneyInput id="minimum" value={minimumCents} onChange={onMinimumCents} className="mt-2" />
        <p className="mt-1 text-xs text-muted-fg">
          Nenhuma faixa cobra abaixo disso — proteção contra erro de digitação.
        </p>
      </div>
      <div>
        <Label htmlFor="max-vacancies">Limite máximo de vagas</Label>
        <Input
          id="max-vacancies"
          type="number"
          min={1}
          value={maxVacancies}
          onChange={(e) => onMaxVacancies(Number.parseInt(e.target.value, 10) || 1)}
          className="mt-2"
        />
        <p className="mt-1 text-xs text-muted-fg">Acima disso vira "fale com a gente".</p>
      </div>
      <div>
        <Label htmlFor="trial-days">Dias de teste grátis</Label>
        <Input
          id="trial-days"
          type="number"
          min={0}
          value={trialDays}
          onChange={(e) => onTrialDays(Number.parseInt(e.target.value, 10) || 0)}
          className="mt-2"
        />
      </div>
    </CardContent>
  </Card>
);
